export const handleLinkClick = (link) => {
	window.open(link, "_blank", "noopener")
}